import { Modal } from "antd";
import styled from "styled-components";

export const VideoModal = styled(Modal)`
  && .ant-modal-content {
    padding: 0;
    overflow: hidden;
    background: #000;
  }

  && .ant-modal-body {
    padding: 0;
  }

  && .ant-modal-close {
    position: fixed;
    top: 32px;
    inset-inline-end: 32px;
    width: 40px;
    height: 40px;
    color: #fff;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 50%;

    &:hover {
      color: #fff;
      background: rgba(0, 0, 0, 0.2);
    }
  }
`;

export const VideoPlayer = styled.video`
  display: block;
  width: 100%;
  max-height: 70vh;
  background: #000;
`;
